import { jwtDecode } from "jwt-decode";

const capitalizeFirstLetter = (word) => {
  if (!word) return ""; // Check if word is empty or undefined
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

function getEmpName(user) {
  let empName;
  if (user.employee) {
    empName = user.employee.firstName + " " + user.employee.lastName;
  }

  if (user.recruiter) {
    empName = user.recruiter.firstName + " " + user.recruiter.lastName;
  }
  return empName;
}

const isAuthenticatedFun = () => {
  const token = localStorage.getItem("token"); // or sessionStorage, or other storage mechanism
  if (!token) return false;

  // Decode the token to check its expiration (assuming JWT)
  const tokenExpiration = jwtDecode(token).exp; // Replace decodeToken with your token decoding logic
  const currentTime = Math.floor(Date.now() / 1000);
  return tokenExpiration > currentTime;
};


export {isAuthenticatedFun, getEmpName, capitalizeFirstLetter}